module.exports = __webpack_public_path__ + "assets/img/confirm.e097963b.png";